import styled from 'styled-components';
import { colors, font, spacing, themes } from '@chegg-ui/theme';
export var ResetPasswordView = styled.div.withConfig({
  componentId: "sc-1qxzme2-0"
})(["display:flex;flex-direction:column;gap:", ";button[disabled]{color:", ";background-color:", ";opacity:0.2;}"], spacing.px32, colors.white, themes.horizon.colors.primary.dark);
export var Form = styled.form.withConfig({
  componentId: "sc-1qxzme2-1"
})(["display:flex;flex-direction:column;gap:", ";"], spacing.px32);
export var SmallerGapContainer = styled.div.withConfig({
  componentId: "sc-1qxzme2-2"
})(["display:flex;flex-direction:column;gap:", ";"], spacing.px16);
export var RecaptchaContainer = styled.div.withConfig({
  componentId: "sc-1qxzme2-3"
})(["display:flex;flex-direction:column;align-items:center;margin:", " 0 ", " 0;"], spacing.px24, spacing.px16);
export var CheckEmailView = styled.div.withConfig({
  componentId: "sc-1qxzme2-4"
})(["display:flex;flex-direction:column;gap:", ";text-align:center;align-items:center;"], spacing.px32);
export var TopContainer = styled.div.withConfig({
  componentId: "sc-1qxzme2-5"
})(["display:flex;flex-direction:column;gap:", ";"], spacing.px8);
export var Paragraph = styled.p.withConfig({
  componentId: "sc-1qxzme2-6"
})(["font-size:", ";line-height:", ";margin:0;"], font.size.px14, font.lineHeight.md);
export var FooterParagraph = styled.p.withConfig({
  componentId: "sc-1qxzme2-7"
})(["font-size:", ";line-height:", ";margin:0;"], font.size.px12, font.lineHeight.md);